import {isEmptyOrNil} from '@ultradent/utilities/EmptyOrNil';
import DistributorListSearch from '@components/distributors/DistributorListSearch';

// Distributor list length threshold to determined when to render list within a grouped accordion
const SEARCH_MIN_THRESHOLD = 15;

const Distributors = ( {list} ) => {
    const noSearch = isEmptyOrNil( list ) || list.length < SEARCH_MIN_THRESHOLD;

    if ( noSearch ) {
        return null;
    }

    return <DistributorListSearch list={list}/>;
}

export default Distributors;